import React from 'react';
import { IconSvgProps } from '@models/common';

const PuzzlePlus: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'>
      <path
        d='M11.1875 21V19.425C11.1875 18.3066 10.3061 17.4 9.21875 17.4C8.13144 17.4 7.25 18.3066 7.25 19.425V21H6.2C4.72986 21 3.99479 21 3.43327 20.7057C2.93935 20.4469 2.53778 20.0338 2.28611 19.5258C2 18.9482 2 18.1921 2 16.68V15.15H3.3125C4.52062 15.15 5.5 14.1426 5.5 12.9C5.5 11.6574 4.52062 10.65 3.3125 10.65H2C2 9.39196 2 8.76294 2.19982 8.26675C2.46624 7.60518 2.97726 7.07956 3.62046 6.80552C4.10285 6.6 4.71441 6.6 5.9375 6.6H6.8125V5.25C6.8125 4.00736 7.79188 3 9 3C10.2081 3 11.1875 4.00736 11.1875 5.25V6.6H12.0625C13.2856 6.6 13.8971 6.6 14.3795 6.80552C15.0227 7.07956 15.5338 7.60518 15.8002 8.26675C16 8.76294 16 9.39196 16 10.65M19 15V18M19 18V21M19 18H16M19 18H22'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PuzzlePlus;
